import { stringify } from 'qs';
import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let PublicSecureUser = {
    allPermission: (callback) => {
        return request({
            url: `${URL_API}/api/sas-school/authorization/list-permission`,
            method: 'GET'
        }, callback)
    },
    addPermissionGroup: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/authorization/update-permission-group`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    searchRole: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-auth/secure/authorization/search-role`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getListRoles: (isGroup, callback) => {
        return request({
            url: `${URL_API}/api/sas-auth/secure/authorization/list-roles/${isGroup}`,
            method: 'GET',
        }, callback)
    },
    createGroup: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-auth/secure/authorization/create-group`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    editGroup: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-auth/secure/authorization/create-group`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detailGroup: (groupId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/authorization/group-detail/${groupId}`,
            method: 'GET',
        }, callback)
    },
}

export default PublicSecureUser
